import {useCallback} from 'react';
import {useAppDispatch} from 'store/hooks';
import type {MergeSuggestionQueueItem} from '../types';
import {setMergeSuggestionQueue} from '../mergeSuggestionQueueSlice';

export const useSetMergeSuggestionQueue = () => {
  const dispatch = useAppDispatch();
  return useCallback(
    (queueItems: MergeSuggestionQueueItem[]) => {
      dispatch(setMergeSuggestionQueue(queueItems));
    },
    [dispatch],
  );
};
